import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import { zLayers } from '@/utils/styling/zLayers'
import {
  EDITOR_ACTIVE_BORDER_WIDTH,
  EDITOR_INACTIVE_BORDER_WIDTH,
} from '@messenger/consts'

export const Alignment = styled(Flex)(
  ({ snap, show, direction }) => css`
    border: ${snap
        ? `${EDITOR_ACTIVE_BORDER_WIDTH}px`
        : `${EDITOR_INACTIVE_BORDER_WIDTH}px`}
      dashed ${direction === 'vertical' ? '#76ef3e' : '#3ecfef'};
    visibility: ${show ? 'visible' : 'hidden'};
    z-index: ${zLayers.topLayer};
    pointer-events: none;
  `,
)
